// extracted by mini-css-extract-plugin
export default {"content":"block-member_content__65Mhs","tip":"block-member_tip__mriaE","text-bold":"block-member_text-bold__kGH-p"};